import React from "react";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";
import { CONTACT } from "../../../constants/contact";

const contactItems = (t) => [
  {
    label: "LINE",
    value: t("line"),
    color: "#06C755",
    onClick: () => {
      window.open(CONTACT.LINE_URL, "_blank");
    },
  },
  {
    label: "Phone",
    value: t("phone"),
    color: "var(--color-primary, #FF6500)",
    onClick: () => {
      window.open(CONTACT.PHONE_TEL, "_blank");
    },
  },
  {
    label: "Service",
    value: t("service"),
    color: "#3b82f6",
    onClick: null,
  },
  {
    label: "Address",
    value: t("address"),
    color: "#8b5cf6",
    onClick: null,
  },
];

const socialLinks = [
  {
    label: "Facebook",
    url: CONTACT.FACEBOOK_URL,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    label: "Instagram",
    url: CONTACT.INSTAGRAM_URL,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    label: "YouTube",
    url: CONTACT.YOUTUBE_URL,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
  {
    label: "Line",
    url: CONTACT.LINE_URL,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/>
      </svg>
    ),
  },
];

const dotStyle = (color) => ({
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: color,
  flexShrink: 0,
});

const SixthSection = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation("sixthPart");

  const items = contactItems(t);

  return (
    <section
      style={{
        backgroundColor: "#1a1a2e",
        padding: isDesktop ? "64px 40px 32px" : "48px 20px 24px",
        color: "#ffffff",
      }}
    >
      {/* Title */}
      <h3
        style={{
          fontSize: isDesktop ? "28px" : "20px",
          fontWeight: 700,
          textAlign: "center",
          marginBottom: isDesktop ? "40px" : "28px",
        }}
      >
        {t("title")}
      </h3>

      {/* Contact Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
          gap: "14px",
          maxWidth: "680px",
          margin: "0 auto",
        }}
      >
        {items.map((item, idx) => (
          <div
            key={idx}
            onClick={item.onClick || undefined}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              padding: "16px 18px",
              borderRadius: "10px",
              backgroundColor: "rgba(255, 255, 255, 0.06)",
              cursor: item.onClick ? "pointer" : "default",
              transition: "background-color 0.15s",
            }}
          >
            <div style={{ ...dotStyle(item.color), marginTop: "5px" }} />
            <div>
              <div
                style={{
                  fontSize: "12px",
                  color: "rgba(255, 255, 255, 0.5)",
                  marginBottom: "3px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {item.label}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: 1.5,
                }}
              >
                {item.value}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tagline above social icons */}
      <p
        style={{
          textAlign: "center",
          fontSize: isDesktop ? "16px" : "14px",
          fontWeight: 600,
          color: "#ffffff",
          marginTop: isDesktop ? "40px" : "28px",
          marginBottom: "16px",
          lineHeight: 1.5,
        }}
      >
        CTS ศูนย์บริการปกป้องสีรถยนต์ ที่รวบรวม<br />
        นวัตกรรมระดับโลกไว้ในที่เดียว
      </p>

      {/* Social Icons — circle style like CTS website */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          marginTop: "8px",
        }}
      >
        {socialLinks.map((link, idx) => (
          <a
            key={idx}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              backgroundColor: "#E53E3E",
              color: "#fff",
              textDecoration: "none",
              fontSize: "18px",
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            title={link.label}
          >
            {link.icon}
          </a>
        ))}
      </div>

      {/* Copyright */}
      <p
        style={{
          textAlign: "center",
          marginTop: isDesktop ? "40px" : "28px",
          fontSize: "12px",
          color: "rgba(255, 255, 255, 0.5)",
        }}
      >
        {t("copyright")}
      </p>
    </section>
  );
};

export default SixthSection;
